export default __webpack_public_path__ + "static/media/careteam_doctor_ref.409706c3.svg";